import React, { useState, useEffect, useContext, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, withRouter } from "react-router-dom";
import { useHistory } from "react-router";
import { Dropdown } from "react-bootstrap";
import OutsideClickHandler from "react-outside-click-handler";
import { ToastContainer } from "react-toastify";

import Visualeditor from "../../Components/Visualeditor/Visualeditor";
import DeletePopup from "../../Components/DeletePopup/DeletePopup";
import Profeature from "../../Components/Profeature/Profeature";
import Shareresume from "../../Components/Shareresume/Shareresume";
import Footer from "../../Components/Footer/Footer";
import EditorNewHeader from "../../Components/Organisms/EditorHeader/EditorHeader";
import EditorNavbar from "../../Components/Organisms/EditorNavBar/EditorNavbar";
import CalculateCompletion from "../../Components/CalculateCompletion/CalculateCompletion";
import SampleContentModal from "../../Components/Modals/SampleContentModal/SampleContentModal";
import LoginPopup from "../../Components/Modals/LoginPopup/LoginPopup";
import SideTemplate from "../../Components/SideTemplate/SideTemplate";
import SectionItem from "../../Components/Editor/SectionItem";
import ResumeUseForm from "../../hooks/editor/resumeUseForm";
import { userParticularGet } from "../../Store/Actions/UserActions";
import Basiceditor from "../../Components/Basiceditor/Basiceditor";
import {
  getResumeById,
  sampleResumeById,
  createResumes,
} from "../../Store/Actions/ResumeActions";
import Picktemplate from "../../Components/Picktemplate/Picktemplate";

import { pageLayoutContext } from "../../Context/PageLayoutContext";
import { userTypeContext } from "../../Context/FreeOrProContext";
import { ExternalUserContext } from "../../Context/externalUserContext";
import { jsonEditorContext } from "../../Context/jsonEditorContext";
import { ResumePopupContext } from "../../Context/resumePopupContext";

import { RESUME_CREATE_RESET } from "../../Store/Constants/ResumeConstants";
import { templateGetActions } from "../../Store/Actions/TemplateActions";

import { timeDifference } from "../../Utils/Common";
import { CalculatecompletedPercentage } from "../../Utils/CalculateCompletion";
import DownloadPopup from "../../Components/DownloadPopup/DownloadPopup";
import EditorSpinner from "../../Utils/EditorSaveSpinner";
import DownloadPdfPopup from "../../Components/DownloadPdf/Profeature";
import RearrangeComponent from "./RearrangeComponent";
import { availableSection } from "../../masterData";
import { Helmet } from "react-helmet";
import "./Editor.scss";
import "./Editorheader.scss";
import "react-toastify/dist/ReactToastify.min.css";
import { analyzeResume } from "../../Store/Actions/AnalyzeActions";
import { undoRedo } from "../../Store/Actions/undoRedoActions";
import SideResumeNavbar from "../../Components/SideResumeNavbar/SideResumeNavbar";
import RemoveProWarning from "../../Components/RemoveProWarning/RemoveProWarning";
import HistoryPopup from "../../Components/Modals/HistoryPopup/HistoryPopup";
import SaveBeforeClosePopup from "../../Components/SaveBeforeClosePopup/SaveBeforeClose";
import { TemplateContext } from "../../Context/templateContext";

function Editor(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const url = window.location.search;
  const path = window.location.pathname;
  const shareUrl = path.split("/");
  const query = new URLSearchParams(window.location.search);
  const job = query.get("job");
  const refer = query.get("refer");
  const queryTemplate = query.get("template");
  const [actionToggle, setActionToggle] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showClosePopup, setShowClosePopup] = useState(false);
  const [leaveUrl, setLeaveUrl] = useState("");
  const [showPremiumIndicator, setShowPremiumIndicator] = useState(false);
  const { resume } = useSelector((state) => state.resumeGetById);
  const loadUserData = useSelector((state) => state.userData.userInfo);
  const editorData = useSelector((state) => state.editorData);
  const create = useSelector((state) => state.createResume);
  const savedTime = useSelector((state) => state.resumeLastUpdatedAt);
  const userData = useSelector((state) => state.particularuser.user);
  const [showDownloadPdfPopup, setShowDownloadPdfPopup] = useState(false);
  const { preview, setPreview } = useContext(ResumePopupContext);
  const historyUndoRedo = useSelector((state) => state.undoRedo);
  const { showTemplate, setShowTemplate } = useContext(TemplateContext);

  const { reArrangeStatus, setReArrangeStatus, isMobile, setIsMobile } =
    useContext(pageLayoutContext);

  useEffect(() => {
    if (resume && resume != "") {
      if (path.includes("create")) {
        if (loadUserData && loadUserData.token) {
          document.cookie = `sample=false; path=/; secure; domain=qwikresume.com; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
          document.cookie = `coverSample=false; path=/; secure; domain=qwikresume.com; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
          localStorage.removeItem("onboardingTemplate");
          let updatedEditorData = { ...editorData };
          updatedEditorData.profile.data[0] = {
            ...updatedEditorData.profile.data[0],
            name: loadUserData?.user?.first_name
              ? loadUserData.user.first_name
              : "",
            email: loadUserData?.user?.email ? loadUserData.user.email : "",
            photo: loadUserData?.user?.profile_image
              ? loadUserData.user.photo
              : "",
            jobTitle:
              updatedEditorData &&
              updatedEditorData.profile &&
              updatedEditorData.profile.data[0].jobTitle
                ? updatedEditorData.profile.data[0].jobTitle
                : loadUserData?.user?.job_title
                ? loadUserData.user.job_title
                : "",
          };
          let data = {};
          data.title =
            resume && resume.job_title
              ? resume && resume.job_title
              : "Untitled";
          data.thumb = "";
          data.type = "resume";
          data.content = JSON.stringify(updatedEditorData);
          data.isLetter = 0;
          data.sample_id = id;
          data.completed = false;
          data.template_id = resume && resume.template_id;

          dispatch(createResumes(data));
        } else {
          if (path.includes("sample") && refer == "resume-samples") {
            const sampleSplit = path.split("/");

            localStorage.setItem(
              "sample_id",
              sampleSplit[sampleSplit && sampleSplit.length - 2]
            );
            history.push("/onboarding");
          } else {
            history.push("/onboarding");
          }
        }
      }
    }
  }, [resume]);

  useEffect(() => {
    if (path.includes("create")) {
      if (preview) {
      } else {
        if (props && props.sample) {
        } else {
          if (
            queryTemplate &&
            queryTemplate != null &&
            queryTemplate &&
            queryTemplate != ""
          ) {
            dispatch(sampleResumeById(id, queryTemplate, "template"));
          } else {
            dispatch(sampleResumeById(id));
          }
        }
      }
    } else {
      if (id && id != "") {
        if (props && props.sample) {
        } else {
          dispatch(getResumeById(id, shareUrl[1]));
        }
      }
    }
  }, [id]);

  useEffect(() => {
    if (!props.previewModal && !props.sample) {
      dispatch(templateGetActions(false));
    }
  }, []);

  useEffect(() => {
    if (
      create &&
      create.create &&
      create.create.type &&
      create.create.type === "resume"
    ) {
      // if (refer && refer == "download_pdf") {
      //   history.push(`/resumes/${create.create.id}/?refer=download_pdf`);
      //   dispatch({ type: RESUME_CREATE_RESET });
      // } else {
      //   history.push(`/resumes/${create.create.id}`);
      //   dispatch({ type: RESUME_CREATE_RESET });
      // }
      if (refer === "download_pdf") {
        dispatch({ type: RESUME_CREATE_RESET });
        window.location.href = `/resumes/${create.create.id}/?refer=download_pdf`;
      } else {
        dispatch({ type: RESUME_CREATE_RESET });
        window.location.href = `/resumes/${create.create.id}`;
      }
    }
  }, [create]);

  useEffect(() => {
    if (
      loadUserData &&
      loadUserData.token &&
      refer &&
      refer == "download_pdf" &&
      path &&
      !path.includes("create")
    ) {
      setShowDownloadPdfPopup(true);
    }
  }, [loadUserData && loadUserData.token]);

  const {
    showProPopup,
    setShowProPopup,
    showProPopupMessage,
    setShowProPopupMessage,
    popupType,
    setPopupType,
    userType,
    setUserType,
  } = useContext(userTypeContext);

  const [Shareurl, setShareURL] = useState();
  const [time, setTime] = useState("");

  const [cover, setCover] = useState("");

  const [deletePopup, setDeletePopup] = useState(false);
  const [editorEventKey, setEditorEventKey] = useState("second");
  const [showPreview, setShowPreview] = useState(false);
  const [showSample, setShowSample] = useState(false);
  const [imgChange, setImgChange] = useState(false);
  const [isVisualEditor, setIsVisualEditor] = useState(true);
  const [modal, setModal] = useState(false);
  const [randUpdate, setRandUpdate] = useState(false);
  const [showMediumDesignbar, setShowMediumDesignbar] = useState(false);

  const backgroundChange = () => {
    setImgChange(true);
  };
  const handleHide = () => {
    setShowLogin(false);
  };
  const showDeletePopup = () => {
    setDeletePopup(true);
  };

  const [duplicateShow, duplicatesetModalShow] = useState(false);
  const duplicatemodal = () => duplicatesetModalShow(true);

  const [shareShow, sharesetModalShow] = useState(false);
  const shareHide = () => sharesetModalShow(false);

  const sharemodal = () => {
    if (isLogin && isLogin) {
      if (userType && userType == "free") {
        setShowProPopup(true);
        setPopupType("share");
        setShowProPopupMessage("Please upgrade to Pro");
      } else {
        sharesetModalShow(true);
      }
    } else {
      setShowLogin(true);
    }
  };

  const toggleSidebar = () => {
    setActionToggle(!actionToggle);
  };
  //   useEffect(() => {
  //     dispatch(userParticularGet());
  //   }, []);

  useEffect(() => {
    const copyURL = window.location.href;
    setShareURL(copyURL);
  }, [url]);

  useEffect(() => {
    if (resume && resume.type === "cover_letter") {
      setCover("cover_letter");
    } else if (resume && resume.type === "resume") {
      setCover("resume");
    }
  }, [resume]);

  const { isLogin } = useContext(ExternalUserContext);

  const hidePreview = () => {
    setShowPreview(false);
  };

  const hideSample = () => {
    setShowSample(false);
    if (path.includes("create")) {
      history.push(`/create-resume/sample/${id}`);
    } else {
      history.push(`/resumes/${id}`);
    }
  };

  useEffect(() => {
    if (job != "" && job != null) {
      setShowSample(true);
    }
  }, [job]);

  const hideShowProPopup = () => {
    setShowProPopup(false);
    duplicatesetModalShow(false);
  };

  const sizeHandle = (checked, type) => {};

  const { json, isJson, setIsJson, isSample, setIsSample } =
    useContext(jsonEditorContext);

  const {
    resumeFields,
    setResumeFields,
    handleEditorChange,
    resumeHandler,
    resumeTitleHandler,
    resumeTitleRemove,
    resumeUpdate,
    resumeNavigateHistory,
    sectionMoveUp,
    sectionMoveDown,
    dateHandler,
    languageHandler,
    addResumeField,
    showHideElements,
    deletePopupShow,
    sizeHandler,
    fontHandler,
    multiColorHandler,
    colorHandler,
    backgroundUpdate,
    handleSectionDelete,
    setSection,
    checkSectionPresentOrNot,
    sectionItemMoveUp,
    sectionItemMoveDown,
    handleItemDelete,
    showHideBackground,
    contentAdder,
    setRandLayout,
    visualEditorFocus,
    setVisualEditorFocus,
    resetImage,
    handleCustomDelete,
    removeProfeatures,
    handleSliderChange,
    handlePageMargin,
    handleSectionMargin,
    skillsLevelHandler,
    bgColorHandler,
    handleBorderChange,
    handleProfileImageChange,
    updateHistoryData,
    resumeUpdateToServer,
    isDataUpdated,
    changeIconSettings,
    handleAchievementSvg,
    handleItemIcon,
    skillsLevelHandlerRcSlider,
    handleLanguageSliderChange,
  } = ResumeUseForm(isJson, json, props.sample, false, isVisualEditor);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!isDataUpdated) return;
      // Cancel the event
      e.preventDefault();
      // Prompt the user with a custom message
      const confirmationMessage = "Are you sure you want to leave?";
      e.returnValue = confirmationMessage;

      // Show confirmation dialog
      const isConfirmed = window.confirm(confirmationMessage);
      if (isConfirmed) {
        resumeUpdateToServer();
        // Perform action here before leaving (e.g., calling an API)
        // Example:
        // callApi();
      }
    };
    const handleVisibilityChange = () => {
      if (!isDataUpdated) return;
      if (document.hidden) {
        resumeUpdateToServer();
      }
    };

    if (path && path.includes("resumes")) {
      window.addEventListener("beforeunload", handleBeforeUnload);
      document.addEventListener("visibilitychange", handleVisibilityChange);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [resume, path, isDataUpdated]);

  // useEffect(() => {
  //   if (resumeFields && resumeFields != "") {
  //     dispatch(analyzeResume(resumeFields));
  //   }
  // }, [resumeFields]);

  const customizationData = useSelector(
    (state) => state.editorData.customization
  );

  const layoutData = useSelector((state) => state.layout);

  const customStyle = isJson ? json && json.customization : customizationData;

  useEffect(() => {
    setIsJson(false);
    setIsSample(false);
    setPreview(false);
  }, []);

  const handleToggle = () => {
    setShowDownloadPdfPopup(false);
    history.push(`/resumes/${id}`);

    if (path && path.includes("create")) {
      setShowLogin(true);
    } else {
      if (userType && userType == "free") {
        let data =
          resumeFields &&
          resumeFields.lockedFeatures &&
          resumeFields.lockedFeatures;
        if (data && data.length > 0) {
          setShowProPopup(true);
          setPopupType("download");
          setShowProPopupMessage("Please upgrade to Pro");
        } else {
          setModal(!modal);
        }
      } else {
        setModal(!modal);
      }
    }
  };

  useEffect(() => {
    if (path && path.includes("preview")) {
      document.getElementById("root").style.backgroundColor =
        customStyle && customStyle.colors && customStyle.colors.bgColor;
      document.body.style.backgroundColor =
        customStyle && customStyle.colors && customStyle.colors.bgColor;
    }
  }, [customStyle]);

  useEffect(() => {
    if (props.preview && !props.previewModal) {
      setIsJson(true);
    }
    if (props && props.sample && !props.previewModal) {
      setIsJson(true);
      setIsSample(true);
    }
    if ((props && props.previewModal) || (props && props.preview)) {
      setVisualEditorFocus(false);
    }
  }, [props]);

  const [isSideBar, setIsSideBar] = useState(false);

  const ShowTemplateSidebar = () => {
    setIsSideBar(!isSideBar);
  };

  const hideTemplate = () => {
    setIsSideBar(false);
  };

  useEffect(() => {
    var interval = "";
    if (savedTime && savedTime.date) {
      let updated = timeDifference(savedTime.date);
      setTime(updated);

      interval = setInterval(() => {
        let updated = timeDifference(savedTime.date);
        setTime(updated);
      }, 10000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [savedTime]);

  const showRearrange = () => {
    setReArrangeStatus(!reArrangeStatus);
  };

  const showSamplePopup = () => {
    setShowSample(true);
  };

  const css = `@media print {
	body {
	  background-color: ${
      customStyle && customStyle.colors && customStyle.colors.bgColor
    } !important;
	}
  }`;

  const hidePlaceholder = `
  .ql-editor.ql-blank::after {
	opacity:0 !important;
  }
  [data-placeholder]:empty:before {
	opacity:0.3 !important;
  }
  `;

  useEffect(() => {
    if (resumeFields?.lockedFeatures?.length > 0) {
      setShowPremiumIndicator(true);
    } else {
      setShowPremiumIndicator(false);
    }
  }, [resumeFields]);

  const handlePayment = () => {
    history.push("/pricingplansnew");
  };

  const handleEditor = (type) => {
    if (reArrangeStatus) {
      setReArrangeStatus(!reArrangeStatus);
      resumeUpdate(true);
    }
    if (type == "basic") {
      setIsVisualEditor(false);
    } else {
      setIsVisualEditor(true);
    }
  };

  //For undo and redo
  function undo(e) {
    resumeNavigateHistory("undo");
  }

  function redo(e) {
    resumeNavigateHistory("redo");
  }

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.ctrlKey && evt.keyCode == 90) {
      undo();
    } else if (evt.ctrlKey && evt.keyCode == 89) {
      redo();
    }
  };
  const handleMediumDesignbar = () => {
    setShowMediumDesignbar(!showMediumDesignbar);
  };
  const [showRemoveProFeatureWarning, setShowRemoveProFeatureWarning] =
    useState(false);
  const removeProfeaturesModal = () => {
    setShowRemoveProFeatureWarning(true);
  };
  const hideRemoveProfeaturesModal = () => {
    setShowRemoveProFeatureWarning(false);
  };

  //History Modal
  const [showHistory, setShowHistory] = useState(false);
  const showHistoryModal = () => {
    setShowHistory(true);
  };
  const hideShowHistorysModal = () => {
    setShowHistory(false);
  };
  const hideClosePopup = () => {
    setShowClosePopup(false);
  };
  return (
    <>
      {path && path.includes("create") ? (
        <></>
      ) : (
        <>
          {Object.keys(resumeFields).length !== 0 && (
            <>
              {path && path.includes("resumes") && (
                <Helmet>
                  <meta
                    name="description"
                    content="Qwikresume.com helps you create compelling resumes with ease using Resume Samples created by Professionals."
                  />
                  <meta
                    name="keywords"
                    content="resume, cover letter, online resume editor, cv, resume builder, create a resume, create cv, resume templates, cv templates"
                  />
                  <meta name="robots" content="noindex, nofollow" />
                  <meta
                    itemprop="name"
                    content="Create your Resume with Ease - Qwikresume"
                  />
                  <meta
                    itemprop="description"
                    content="Qwikresume.com helps you create compelling resumes with ease using Resume Samples created by Professionals."
                  />
                  <title>Resume Editor - Qwikresume.com</title>
                </Helmet>
              )}

              {path && path.includes("qr") && <style>{css}</style>}
              {(path && path.includes("preview")) ||
              (props && props.previewModal) ? (
                <style>{hidePlaceholder}</style>
              ) : (
                ""
              )}
              {(path && path.includes("preview")) ||
              (path && path.includes("qr")) ? (
                <>
                  <div style={{ pointerEvents: "none" }}>
                    {resume && (
                      <Visualeditor
                        url={url}
                        shareShow={sharemodal}
                        actionToggle={actionToggle}
                        setActionToggle={toggleSidebar}
                        setShowPreview={setShowPreview}
                        setShowSample={setShowSample}
                        imgShow={backgroundChange}
                        sizeHandle={sizeHandle}
                        resumeFields={resumeFields}
                        resumeHandler={resumeHandler}
                        resumeTitleHandler={resumeTitleHandler}
                        resumeUpdate={resumeUpdate}
                        handleEditorChange={handleEditorChange}
                        dateHandler={dateHandler}
                        languageHandler={languageHandler}
                        addResumeField={addResumeField}
                        showHideElements={showHideElements}
                        sectionMoveUp={sectionMoveUp}
                        sectionMoveDown={sectionMoveDown}
                        deletePopupShow={deletePopupShow}
                        visualEditorFocus={visualEditorFocus}
                        setVisualEditorFocus={setVisualEditorFocus}
                        previewModal={props.previewModal}
                        sample={props.sample}
                        preview={props.preview}
                        skillsLevelHandler={skillsLevelHandler}
                        handleBorderChange={handleBorderChange}
                        handleAchievementSvg={handleAchievementSvg}
                        handleItemIcon={handleItemIcon}
                        skillsLevelHandlerRcSlider={skillsLevelHandlerRcSlider}
                        handleLanguageSliderChange={handleLanguageSliderChange}
                      />
                    )}
                  </div>
                </>
              ) : props && props.sample ? (
                <>
                  <Visualeditor
                    url={url}
                    shareShow={sharemodal}
                    actionToggle={actionToggle}
                    setActionToggle={toggleSidebar}
                    setShowPreview={setShowPreview}
                    setShowSample={setShowSample}
                    imgShow={backgroundChange}
                    sizeHandle={sizeHandle}
                    resumeFields={resumeFields}
                    resumeHandler={resumeHandler}
                    resumeTitleHandler={resumeTitleHandler}
                    resumeUpdate={resumeUpdate}
                    handleEditorChange={handleEditorChange}
                    dateHandler={dateHandler}
                    languageHandler={languageHandler}
                    addResumeField={addResumeField}
                    showHideElements={showHideElements}
                    sectionMoveUp={sectionMoveUp}
                    sectionMoveDown={sectionMoveDown}
                    deletePopupShow={deletePopupShow}
                    visualEditorFocus={visualEditorFocus}
                    setVisualEditorFocus={setVisualEditorFocus}
                    previewModal={props.previewModal}
                    sample={props.sample}
                    preview={props.preview}
                    skillsLevelHandler={skillsLevelHandler}
                    handleBorderChange={handleBorderChange}
                    handleAchievementSvg={handleAchievementSvg}
                    handleItemIcon={handleItemIcon}
                    skillsLevelHandlerRcSlider={skillsLevelHandlerRcSlider}
                    handleLanguageSliderChange={handleLanguageSliderChange}
                  />
                </>
              ) : props && props.preview ? (
                <>
                  {resume && (
                    <Visualeditor
                      url={url}
                      shareShow={sharemodal}
                      actionToggle={actionToggle}
                      setActionToggle={toggleSidebar}
                      setShowPreview={setShowPreview}
                      setShowSample={setShowSample}
                      imgShow={backgroundChange}
                      sizeHandle={sizeHandle}
                      resumeFields={resumeFields}
                      resumeHandler={resumeHandler}
                      resumeTitleHandler={resumeTitleHandler}
                      resumeUpdate={resumeUpdate}
                      handleEditorChange={handleEditorChange}
                      dateHandler={dateHandler}
                      languageHandler={languageHandler}
                      addResumeField={addResumeField}
                      showHideElements={showHideElements}
                      sectionMoveUp={sectionMoveUp}
                      sectionMoveDown={sectionMoveDown}
                      deletePopupShow={deletePopupShow}
                      visualEditorFocus={visualEditorFocus}
                      setVisualEditorFocus={setVisualEditorFocus}
                      previewModal={props.previewModal}
                      sample={props.sample}
                      preview={props.preview}
                      skillsLevelHandler={skillsLevelHandler}
                      handleBorderChange={handleBorderChange}
                      handleAchievementSvg={handleAchievementSvg}
                      handleItemIcon={handleItemIcon}
                      skillsLevelHandlerRcSlider={skillsLevelHandlerRcSlider}
                      handleLanguageSliderChange={handleLanguageSliderChange}
                    />
                  )}
                </>
              ) : (
                <>
                  <div className="app-wrapper">
                    <ToastContainer
                      toastStyle={{
                        backgroundColor: "#009c61",
                        width: "203px",
                        fontSize: "12px",
                        minHeight: "30px",
                        float: "right",
                        marginTop: "15%",
                      }}
                      position="top-right"
                      hideProgressBar
                      autoClose={2000}
                      draggable
                    />

                    {resume && (
                      <React.Fragment>
                        <Profeature
                          popupType={popupType}
                          show={showProPopup}
                          onHide={hideShowProPopup}
                          showProPopupMessage={showProPopupMessage}
                        />
                        <RemoveProWarning
                          show={showRemoveProFeatureWarning}
                          removeProfeatures={removeProfeatures}
                          onHide={hideRemoveProfeaturesModal}
                        />
                        {/* <SaveBeforeClosePopup leaveUrl={leaveUrl} show={showClosePopup} hidePopup={hideClosePopup} resumeUpdateToServer={resumeUpdateToServer}/> */}

                        <LoginPopup
                          show={showLogin}
                          hide={handleHide}
                          resumeFields={resumeFields}
                          setResumeFields={setResumeFields}
                        />
                        <HistoryPopup
                          showHistory={showHistory}
                          showHistoryModal={showHistoryModal}
                          hideShowHistorysModal={hideShowHistorysModal}
                          updateHistoryData={updateHistoryData}
                        />
                        <DownloadPdfPopup
                          showDownloadPdfPopup={showDownloadPdfPopup}
                          setShowDownloadPdfPopup={setShowDownloadPdfPopup}
                          handleToggle={handleToggle}
                          id={id}
                        />
                        {modal && modal && (
                          <DownloadPopup
                            show={modal}
                            handleToggle={handleToggle}
                            type="resume"
                          />
                        )}
                        <Picktemplate
                          isSideBar={isSideBar}
                          hideTemplate={hideTemplate}
                          resumeFields={resumeFields}
                          setResumeFields={setResumeFields}
                          bgColorHandler={bgColorHandler}
                          url={url}
                          shareShow={sharemodal}
                          actionToggle={actionToggle}
                          setActionToggle={toggleSidebar}
                          setShowPreview={setShowPreview}
                          setShowSample={setShowSample}
                          imgShow={backgroundChange}
                          sizeHandle={sizeHandle}
                          resumeHandler={resumeHandler}
                          resumeTitleHandler={resumeTitleHandler}
                          resumeTitleRemove={resumeTitleRemove}
                          resumeUpdate={resumeUpdate}
                          handleEditorChange={handleEditorChange}
                          dateHandler={dateHandler}
                          languageHandler={languageHandler}
                          addResumeField={addResumeField}
                          showHideElements={showHideElements}
                          sectionMoveUp={sectionMoveUp}
                          sectionMoveDown={sectionMoveDown}
                          deletePopupShow={deletePopupShow}
                          sectionItemMoveUp={sectionItemMoveUp}
                          sectionItemMoveDown={sectionItemMoveDown}
                          handleItemDelete={handleItemDelete}
                          showHideBackground={showHideBackground}
                          contentAdder={contentAdder}
                          // setResumeFields={setResumeFields}
                          visualEditorFocus={visualEditorFocus}
                          setVisualEditorFocus={setVisualEditorFocus}
                          previewModal={props.previewModal}
                          sample={props.sample}
                          preview={props.preview}
                          handleSliderChange={handleSliderChange}
                          handleProfileImageChange={handleProfileImageChange}
                          handleEditor={handleEditor}
                          skillsLevelHandler={skillsLevelHandler}
                          handleBorderChange={handleBorderChange}
                        />
                        <Shareresume
                          show={shareShow}
                          cover={cover}
                          shareHide={shareHide}
                          Shareurl={Shareurl}
                          resumeId={resume && resume.random_code}
                        />
                        <SampleContentModal
                          showSample={showSample}
                          job={job}
                          hideSample={hideSample}
                          resumeFields={resumeFields}
                          setResumeFields={setResumeFields}
                          setRandLayout={setRandLayout}
                        />
                        <DeletePopup
                          handleSectionDelete={handleSectionDelete}
                        />
                        <OutsideClickHandler
                          onOutsideClick={(e, value) => {
                            const parentWithClass = e.target.closest(
                              ".medium-parent-desingerbar-wrapper"
                            );
                            const anotherParentWithClass =
                              e.target.closest(".sidebarResume");
                            const anotherParentWithHeadClass = e.target.closest(
                              ".editor-header-ellipsis"
                            );
                            if (
                              showMediumDesignbar &&
                              parentWithClass == null &&
                              anotherParentWithClass == null &&
                              anotherParentWithHeadClass == null
                            ) {
                              setShowMediumDesignbar(false);
                            } else if (
                              showMediumDesignbar &&
                              parentWithClass != ""
                            ) {
                              setShowMediumDesignbar(true);
                            }
                          }}
                        >
                          <SideResumeNavbar
                            showMediumDesignbar={showMediumDesignbar}
                            setShowMediumDesignbar={setShowMediumDesignbar}
                          >
                            <EditorNavbar
                              cover={cover}
                              setEditorEventKey={setEditorEventKey}
                              editorEventKey={editorEventKey}
                              duplicateShow={duplicatemodal}
                              shareShow={sharemodal}
                              setActionToggle={toggleSidebar}
                              showDeletePopup={showDeletePopup}
                              showSamplePopup={showSamplePopup}
                              id={id}
                              showPreview={showPreview}
                              hidePreview={hidePreview}
                              sizeHandle={sizeHandle}
                              ShowTemplate={ShowTemplateSidebar}
                              sizeHandler={sizeHandler}
                              fontHandler={fontHandler}
                              multiColorHandler={multiColorHandler}
                              colorHandler={colorHandler}
                              backgroundUpdate={backgroundUpdate}
                              resumeUpdate={resumeUpdate}
                              resumeFields={resumeFields}
                              setResumeFields={setResumeFields}
                              setIsSample={setIsSample}
                              handleEditor={handleEditor}
                              showRearrange={showRearrange}
                              checkSectionPresentOrNot={
                                checkSectionPresentOrNot
                              }
                              setSection={setSection}
                              isVisualEditor={isVisualEditor}
                              undo={undo}
                              redo={redo}
                              handlePageMargin={handlePageMargin}
                              handleSectionMargin={handleSectionMargin}
                              bgColorHandler={bgColorHandler}
                              showHistoryModal={showHistoryModal}
                              resumeUpdateToServer={resumeUpdateToServer}
                              showHideBackground={showHideBackground}
                            />
                          </SideResumeNavbar>
                        </OutsideClickHandler>
                        <div className="editor-header-div">
                          <EditorNewHeader
                            resumeFields={resumeFields}
                            setResumeFields={setResumeFields}
                            handleEditor={handleEditor}
                            isVisualEditor={isVisualEditor}
                            handleMediumDesignbar={handleMediumDesignbar}
                            isMobile={isMobile}
                            setShowClosePopup={setShowClosePopup}
                            setLeaveUrl={setLeaveUrl}
                            path={path}
                            isDataUpdated={isDataUpdated}
                            resumeUpdateToServer={resumeUpdateToServer}
                          />
                        </div>

                        {reArrangeStatus && reArrangeStatus && customStyle ? (
                          <RearrangeComponent
                            isJson={isJson}
                            json={json}
                            customStyle={customStyle}
                            layoutData={layoutData}
                            resumeFields={resumeFields}
                            setResumeFields={setResumeFields}
                            resumeUpdate={resumeUpdate}
                          />
                        ) : (
                          ""
                        )}
                        <div className="d-flex justify-content-center">
                          <div>
                            {reArrangeStatus ? (
                              <></>
                            ) : (
                              <>
                                <div className=" d-none d-sm-none d-md-block d-lg-none d-xl-none">
                                  <div
                                    className="medium-parent-desingerbar"
                                    onClick={handleMediumDesignbar}
                                  >
                                    <i
                                      class="fa fa-ellipsis-h"
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                </div>
                                {/* {showMediumDesignbar && (
                          <OutsideClickHandler
                            onOutsideClick={(e, value) => {
                              const parentWithClass = e.target.closest(
                                ".medium-parent-desingerbar-wrapper"
                              );
                              const anotherParentWithClass = e.target.closest(
                                ".medium-parent-desingerbar"
                              );
                              const anotherParentWithHeadClass =
                                e.target.closest(".editor-header-ellipsis");
                              if (
                                showMediumDesignbar &&
                                parentWithClass == null &&
                                anotherParentWithClass == null &&
                                anotherParentWithHeadClass == null
                              ) {
                                setShowMediumDesignbar(false);
                              } else if (
                                showMediumDesignbar &&
                                parentWithClass != ""
                              ) {
                                setShowMediumDesignbar(true);
                              }
                            }}
                          >
                            <div
                              style={{ backgroundColor: "#ffffff" }}
                              className="medium-parent-desingerbar-wrapper"
                            >
                              {" "}
                              <EditorNavbar
                                cover={cover}
                                setEditorEventKey={setEditorEventKey}
                                editorEventKey={editorEventKey}
                                duplicateShow={duplicatemodal}
                                shareShow={sharemodal}
                                setActionToggle={toggleSidebar}
                                showDeletePopup={showDeletePopup}
                                showSamplePopup={showSamplePopup}
                                id={id}
                                showPreview={showPreview}
                                hidePreview={hidePreview}
                                sizeHandle={sizeHandle}
                                ShowTemplate={ShowTemplateSidebar}
                                sizeHandler={sizeHandler}
                                fontHandler={fontHandler}
                                multiColorHandler={multiColorHandler}
                                colorHandler={colorHandler}
                                backgroundUpdate={backgroundUpdate}
                                resumeUpdate={resumeUpdate}
                                resumeFields={resumeFields}
                                setResumeFields={setResumeFields}
                                setIsSample={setIsSample}
                                handleEditor={handleEditor}
                                showRearrange={showRearrange}
                                checkSectionPresentOrNot={
                                  checkSectionPresentOrNot
                                }
                                setSection={setSection}
                                isVisualEditor={isVisualEditor}
                              />
                            </div>
                          </OutsideClickHandler>
                        )} */}

                                <div
                                  className="d-none d-sm-none d-md-none d-lg-block"
                                  style={{ marginTop: "77px" }}
                                >
                                  <EditorNavbar
                                    cover={cover}
                                    setEditorEventKey={setEditorEventKey}
                                    editorEventKey={editorEventKey}
                                    duplicateShow={duplicatemodal}
                                    shareShow={sharemodal}
                                    setActionToggle={toggleSidebar}
                                    showDeletePopup={showDeletePopup}
                                    showSamplePopup={showSamplePopup}
                                    id={id}
                                    showPreview={showPreview}
                                    hidePreview={hidePreview}
                                    sizeHandle={sizeHandle}
                                    ShowTemplate={ShowTemplateSidebar}
                                    sizeHandler={sizeHandler}
                                    fontHandler={fontHandler}
                                    multiColorHandler={multiColorHandler}
                                    colorHandler={colorHandler}
                                    backgroundUpdate={backgroundUpdate}
                                    resumeUpdate={resumeUpdate}
                                    resumeFields={resumeFields}
                                    setResumeFields={setResumeFields}
                                    setIsSample={setIsSample}
                                    handleEditor={handleEditor}
                                    showRearrange={showRearrange}
                                    checkSectionPresentOrNot={
                                      checkSectionPresentOrNot
                                    }
                                    setSection={setSection}
                                    isVisualEditor={isVisualEditor}
                                    undo={undo}
                                    redo={redo}
                                    handlePageMargin={handlePageMargin}
                                    handleSectionMargin={handleSectionMargin}
                                    bgColorHandler={bgColorHandler}
                                    showHistoryModal={showHistoryModal}
                                    resumeUpdateToServer={resumeUpdateToServer}
                                    showHideBackground={showHideBackground}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                          <div>
                            {isMobile && isMobile ? (
                              <>
                                <div
                                  className={`${
                                    reArrangeStatus ? "basic-editor-parent" : ""
                                  }`}
                                >
                                  <Basiceditor
                                    isMobile={isMobile}
                                    url={url}
                                    shareShow={sharemodal}
                                    actionToggle={actionToggle}
                                    setActionToggle={toggleSidebar}
                                    setShowPreview={setShowPreview}
                                    setShowSample={setShowSample}
                                    imgShow={backgroundChange}
                                    sizeHandle={sizeHandle}
                                    resumeFields={resumeFields}
                                    resumeHandler={resumeHandler}
                                    resumeTitleHandler={resumeTitleHandler}
                                    resumeTitleRemove={resumeTitleRemove}
                                    resumeUpdate={resumeUpdate}
                                    handleEditorChange={handleEditorChange}
                                    dateHandler={dateHandler}
                                    languageHandler={languageHandler}
                                    addResumeField={addResumeField}
                                    showHideElements={showHideElements}
                                    sectionMoveUp={sectionMoveUp}
                                    sectionMoveDown={sectionMoveDown}
                                    deletePopupShow={deletePopupShow}
                                    sectionItemMoveUp={sectionItemMoveUp}
                                    sectionItemMoveDown={sectionItemMoveDown}
                                    handleItemDelete={handleItemDelete}
                                    showHideBackground={showHideBackground}
                                    contentAdder={contentAdder}
                                    setResumeFields={setResumeFields}
                                    visualEditorFocus={visualEditorFocus}
                                    setVisualEditorFocus={setVisualEditorFocus}
                                    resetImage={resetImage}
                                    handleCustomDelete={handleCustomDelete}
                                    handleSliderChange={handleSliderChange}
                                    handleProfileImageChange={
                                      handleProfileImageChange
                                    }
                                  />
                                  {showPremiumIndicator &&
                                    showPremiumIndicator &&
                                    userType &&
                                    userType != "pro" &&
                                    isVisualEditor && (
                                      <>
                                        <div className="Premium-indicator-popup">
                                          <div className="row">
                                            <div className="col-md-8 col-12 col-sm-12 align-self-center">
                                              <p className="pro-indicator-text">
                                                This Resume is using Pro
                                                features.You need to remove them
                                                or upgrade to download.
                                              </p>
                                            </div>
                                            <div className="col-md-4 col-12 col-sm-12">
                                              <div className="d-flex">
                                                {path &&
                                                path.includes("create") ? (
                                                  <>
                                                    <div>
                                                      <button
                                                        className="btn removepro-upgrade"
                                                        onClick={() =>
                                                          setShowLogin(true)
                                                        }
                                                      >
                                                        Sign In
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <>
                                                    <div>
                                                      <button
                                                        className="btn removepro-upgrade"
                                                        onClick={() =>
                                                          handlePayment()
                                                        }
                                                      >
                                                        Upgrade
                                                      </button>
                                                    </div>
                                                  </>
                                                )}
                                                <div
                                                  className="ml-2 editor-remove-pro"
                                                  onClick={() =>
                                                    removeProfeaturesModal()
                                                  }
                                                >
                                                  Remove pro features
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  <div className="mobile-dimension-desktop">
                                    <Visualeditor
                                      url={url}
                                      shareShow={sharemodal}
                                      actionToggle={actionToggle}
                                      setActionToggle={toggleSidebar}
                                      setShowPreview={setShowPreview}
                                      setShowSample={setShowSample}
                                      imgShow={backgroundChange}
                                      sizeHandle={sizeHandle}
                                      resumeFields={resumeFields}
                                      resumeHandler={resumeHandler}
                                      resumeTitleHandler={resumeTitleHandler}
                                      resumeTitleRemove={resumeTitleRemove}
                                      resumeUpdate={resumeUpdate}
                                      handleEditorChange={handleEditorChange}
                                      dateHandler={dateHandler}
                                      languageHandler={languageHandler}
                                      addResumeField={addResumeField}
                                      showHideElements={showHideElements}
                                      sectionMoveUp={sectionMoveUp}
                                      sectionMoveDown={sectionMoveDown}
                                      deletePopupShow={deletePopupShow}
                                      sectionItemMoveUp={sectionItemMoveUp}
                                      sectionItemMoveDown={sectionItemMoveDown}
                                      handleItemDelete={handleItemDelete}
                                      showHideBackground={showHideBackground}
                                      contentAdder={contentAdder}
                                      setResumeFields={setResumeFields}
                                      visualEditorFocus={visualEditorFocus}
                                      setVisualEditorFocus={
                                        setVisualEditorFocus
                                      }
                                      previewModal={props.previewModal}
                                      sample={props.sample}
                                      preview={props.preview}
                                      handleSliderChange={handleSliderChange}
                                      handleProfileImageChange={
                                        handleProfileImageChange
                                      }
                                      handleEditor={handleEditor}
                                      skillsLevelHandler={skillsLevelHandler}
                                      handleBorderChange={handleBorderChange}
                                      changeIconSettings={changeIconSettings}
                                      handleAchievementSvg={
                                        handleAchievementSvg
                                      }
                                      handleItemIcon={handleItemIcon}
                                      skillsLevelHandlerRcSlider={
                                        skillsLevelHandlerRcSlider
                                      }
                                      handleLanguageSliderChange={
                                        handleLanguageSliderChange
                                      }
                                    />
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                <div
                                  className={`${
                                    reArrangeStatus
                                      ? "visual-editor-parent"
                                      : "editor-wrapper"
                                  }`}
                                >
                                  {isVisualEditor ? (
                                    <>
                                      {/* <div className="d-flex pb-3">
                                <div className="history-btn-wrapper pt-0 pl-0 ">
                                  <button>
                                    {historyUndoRedo?.history?.currentIndex >
                                    0 ? (
                                      <div onClick={(e) => undo("undo")}>
                                        <img
                                          src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/undo.svg`}
                                          className="mr-2"
                                        />
                                        Undo
                                      </div>
                                    ) : (
                                      <>
                                        <img
                                          src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/undo.svg`}
                                          className="mr-2"
                                        />
                                        Undo
                                      </>
                                    )}
                                  </button>
                                </div>
                                <div className="history-btn-wrapper pt-0">
                                  {historyUndoRedo && (
                                    <button>
                                      {historyUndoRedo.history.currentIndex !=
                                      historyUndoRedo.history.timeline.length -
                                        1 ? (
                                        <div onClick={(e) => redo("redo")}>
                                          <img
                                            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/redo.svg`}
                                            className="mr-2"
                                          />{" "}
                                          Redo
                                        </div>
                                      ) : (
                                        <>
                                          <img
                                            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/redo.svg`}
                                            className="mr-2"
                                          />{" "}
                                          Redo
                                        </>
                                      )}
                                    </button>
                                  )}
                                </div>
                              </div> */}
                                      <CalculateCompletion
                                        resumeFields={resumeFields}
                                        setSection={setSection}
                                      />
                                      {!showTemplate && (
                                        <Visualeditor
                                          url={url}
                                          shareShow={sharemodal}
                                          actionToggle={actionToggle}
                                          setActionToggle={toggleSidebar}
                                          setShowPreview={setShowPreview}
                                          setShowSample={setShowSample}
                                          imgShow={backgroundChange}
                                          sizeHandle={sizeHandle}
                                          resumeFields={resumeFields}
                                          resumeHandler={resumeHandler}
                                          resumeTitleHandler={
                                            resumeTitleHandler
                                          }
                                          resumeTitleRemove={resumeTitleRemove}
                                          resumeUpdate={resumeUpdate}
                                          handleEditorChange={
                                            handleEditorChange
                                          }
                                          dateHandler={dateHandler}
                                          languageHandler={languageHandler}
                                          addResumeField={addResumeField}
                                          showHideElements={showHideElements}
                                          sectionMoveUp={sectionMoveUp}
                                          sectionMoveDown={sectionMoveDown}
                                          deletePopupShow={deletePopupShow}
                                          sectionItemMoveUp={sectionItemMoveUp}
                                          sectionItemMoveDown={
                                            sectionItemMoveDown
                                          }
                                          handleItemDelete={handleItemDelete}
                                          showHideBackground={
                                            showHideBackground
                                          }
                                          contentAdder={contentAdder}
                                          setResumeFields={setResumeFields}
                                          visualEditorFocus={visualEditorFocus}
                                          setVisualEditorFocus={
                                            setVisualEditorFocus
                                          }
                                          previewModal={props.previewModal}
                                          sample={props.sample}
                                          preview={props.preview}
                                          handleSliderChange={
                                            handleSliderChange
                                          }
                                          handleProfileImageChange={
                                            handleProfileImageChange
                                          }
                                          skillsLevelHandler={
                                            skillsLevelHandler
                                          }
                                          handleBorderChange={
                                            handleBorderChange
                                          }
                                          changeIconSettings={
                                            changeIconSettings
                                          }
                                          handleAchievementSvg={
                                            handleAchievementSvg
                                          }
                                          handleItemIcon={handleItemIcon}
                                          skillsLevelHandlerRcSlider={
                                            skillsLevelHandlerRcSlider
                                          }
                                          handleLanguageSliderChange={
                                            handleLanguageSliderChange
                                          }
                                        />
                                      )}

                                      {showPremiumIndicator &&
                                        showPremiumIndicator &&
                                        userType &&
                                        userType != "pro" &&
                                        isVisualEditor && (
                                          <>
                                            <div className="Premium-indicator-popup">
                                              <div className="row">
                                                <div className="col-md-8 col-12 col-sm-12 align-self-center">
                                                  <p className="pro-indicator-text">
                                                    This Resume is using Pro
                                                    features.You need to remove
                                                    them or upgrade to download.
                                                  </p>
                                                </div>
                                                <div className="col-md-4 col-12 col-sm-12">
                                                  <div className="d-flex">
                                                    {path &&
                                                    path.includes("create") ? (
                                                      <>
                                                        <div>
                                                          <button
                                                            className="btn removepro-upgrade"
                                                            onClick={() =>
                                                              setShowLogin(true)
                                                            }
                                                          >
                                                            Sign In
                                                          </button>
                                                        </div>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <div>
                                                          <button
                                                            className="btn removepro-upgrade"
                                                            onClick={() =>
                                                              handlePayment()
                                                            }
                                                          >
                                                            Upgrade
                                                          </button>
                                                        </div>
                                                      </>
                                                    )}
                                                    <div
                                                      className="ml-2 editor-remove-pro"
                                                      onClick={() =>
                                                        removeProfeaturesModal()
                                                      }
                                                    >
                                                      Remove pro features
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                    </>
                                  ) : (
                                    <>
                                      <div className="d-flex">
                                        <div className="col-md-8 offset-md-2 offset-lg-2 offset-xl-0 col-sm-12 col-12 pl-5">
                                          <CalculateCompletion
                                            resumeFields={resumeFields}
                                            setSection={setSection}
                                          />
                                          <Basiceditor
                                            url={url}
                                            isMobile={isMobile}
                                            shareShow={sharemodal}
                                            actionToggle={actionToggle}
                                            setActionToggle={toggleSidebar}
                                            setShowPreview={setShowPreview}
                                            setShowSample={setShowSample}
                                            imgShow={backgroundChange}
                                            sizeHandle={sizeHandle}
                                            resumeFields={resumeFields}
                                            resumeHandler={resumeHandler}
                                            resumeTitleHandler={
                                              resumeTitleHandler
                                            }
                                            resumeTitleRemove={
                                              resumeTitleRemove
                                            }
                                            resumeUpdate={resumeUpdate}
                                            handleEditorChange={
                                              handleEditorChange
                                            }
                                            dateHandler={dateHandler}
                                            languageHandler={languageHandler}
                                            addResumeField={addResumeField}
                                            showHideElements={showHideElements}
                                            sectionMoveUp={sectionMoveUp}
                                            sectionMoveDown={sectionMoveDown}
                                            deletePopupShow={deletePopupShow}
                                            sectionItemMoveUp={
                                              sectionItemMoveUp
                                            }
                                            sectionItemMoveDown={
                                              sectionItemMoveDown
                                            }
                                            handleItemDelete={handleItemDelete}
                                            showHideBackground={
                                              showHideBackground
                                            }
                                            contentAdder={contentAdder}
                                            setResumeFields={setResumeFields}
                                            visualEditorFocus={
                                              visualEditorFocus
                                            }
                                            setVisualEditorFocus={
                                              setVisualEditorFocus
                                            }
                                            resetImage={resetImage}
                                            handleCustomDelete={
                                              handleCustomDelete
                                            }
                                            handleSliderChange={
                                              handleSliderChange
                                            }
                                            handleProfileImageChange={
                                              handleProfileImageChange
                                            }
                                          />

                                          {showPremiumIndicator &&
                                            showPremiumIndicator &&
                                            userType &&
                                            userType != "pro" && (
                                              <>
                                                <div className="Premium-basic-editor-indicator-popup">
                                                  <div className="row">
                                                    <div className="col-md-8 align-self-center">
                                                      <p className="pro-indicator-text">
                                                        This Resume is using Pro
                                                        features.You need to
                                                        remove them or upgrade
                                                        to download.
                                                      </p>
                                                    </div>
                                                    <div className="col-md-4">
                                                      <div className="d-flex">
                                                        {path &&
                                                        path.includes(
                                                          "create"
                                                        ) ? (
                                                          <>
                                                            <div>
                                                              <button
                                                                className="btn removepro-upgrade"
                                                                onClick={() =>
                                                                  setShowLogin(
                                                                    true
                                                                  )
                                                                }
                                                              >
                                                                Sign In
                                                              </button>
                                                            </div>
                                                          </>
                                                        ) : (
                                                          <>
                                                            <div>
                                                              <button
                                                                className="btn removepro-upgrade"
                                                                onClick={() =>
                                                                  handlePayment()
                                                                }
                                                              >
                                                                Upgrade
                                                              </button>
                                                            </div>
                                                          </>
                                                        )}
                                                        <div
                                                          className="ml-2 editor-remove-pro"
                                                          onClick={() =>
                                                            removeProfeaturesModal()
                                                          }
                                                        >
                                                          Remove pro features
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            )}
                                        </div>
                                        <div className="col-md-4 d-none d-xl-block">
                                          <div>
                                            <div className="desktop-basic-side-preview">
                                              <Visualeditor
                                                url={url}
                                                shareShow={sharemodal}
                                                actionToggle={actionToggle}
                                                setActionToggle={toggleSidebar}
                                                setShowPreview={setShowPreview}
                                                setShowSample={setShowSample}
                                                imgShow={backgroundChange}
                                                sizeHandle={sizeHandle}
                                                resumeFields={resumeFields}
                                                resumeHandler={resumeHandler}
                                                resumeTitleHandler={
                                                  resumeTitleHandler
                                                }
                                                resumeUpdate={resumeUpdate}
                                                handleEditorChange={
                                                  handleEditorChange
                                                }
                                                dateHandler={dateHandler}
                                                languageHandler={
                                                  languageHandler
                                                }
                                                addResumeField={addResumeField}
                                                showHideElements={
                                                  showHideElements
                                                }
                                                sectionMoveUp={sectionMoveUp}
                                                sectionMoveDown={
                                                  sectionMoveDown
                                                }
                                                deletePopupShow={
                                                  deletePopupShow
                                                }
                                                visualEditorFocus={
                                                  visualEditorFocus
                                                }
                                                setVisualEditorFocus={
                                                  setVisualEditorFocus
                                                }
                                                previewModal={true}
                                                sample={true}
                                                preview={true}
                                                isSplit={true}
                                                handleSliderChange={
                                                  handleSliderChange
                                                }
                                                handleProfileImageChange={
                                                  handleProfileImageChange
                                                }
                                                handleEditor={handleEditor}
                                                skillsLevelHandler={
                                                  skillsLevelHandler
                                                }
                                                handleBorderChange={
                                                  handleBorderChange
                                                }
                                                changeIconSettings={
                                                  changeIconSettings
                                                }
                                                handleAchievementSvg={
                                                  handleAchievementSvg
                                                }
                                                handleItemIcon={handleItemIcon}
                                                skillsLevelHandlerRcSlider={
                                                  skillsLevelHandlerRcSlider
                                                }
                                                handleLanguageSliderChange={
                                                  handleLanguageSliderChange
                                                }
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  </div>

                  <Footer />
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}

export default Editor;
